import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {ConfigProvider, message} from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

// 全局配置
message.config({
	top: 100, // 消息框距离顶部的距离
	duration: 6, // 消息框显示的时长，单位为秒
	maxCount: 1, // 最大显示的消息数量
});

ReactDOM.render(
	<ConfigProvider locale={zh_CN}>
		<App/>
	</ConfigProvider>
	,
	document.getElementById('root'),     // 指向 public/index.html
);